module.exports = __webpack_public_path__ + "img/gbwhatsapp-screen-2.64fdd984.webp";